import { useState } from "react";
import { Table, Text } from "$components";
import JTable from "$components/JTable/JTable";
import { theme } from "$utils/theme/bataillog";
import { bodyData, thead } from "./tableData";
import { columns, data } from "./jTableData";

const rowsPerPage = 10;

function Tables() {
  const [pageIndex, setPageIndex] = useState(0);
  const pageCount = Math.ceil(data.length / rowsPerPage);

  return (
    <>
      <Text type="h3">Table</Text>
      <Text style={{ marginBottom: theme.spacing(2) }}>
        <i>Composant très peu utilisé, pourrait bientôt disparaître (?)</i>
      </Text>

      <Table rowsPerPage={20} thead={thead} bodyData={bodyData} />

      <Text type="h3">JTable</Text>
      <Text style={{ marginBottom: theme.spacing(2) }}>
        {rowsPerPage} lignes par page, {pageCount} pages
      </Text>
      <JTable
        data={data.slice(
          pageIndex * rowsPerPage,
          (pageIndex + 1) * rowsPerPage
        )}
        columns={columns}
        setFilter={() => null}
        setPageIndex={setPageIndex}
        pageIndex={pageIndex}
        pageCount={pageCount}
      />
    </>
  );
}

export default Tables;
